import React from 'react';

import DefaultProfileImage from 'assets/images/default-profile-img.png';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';

import Icon from '../../components/Icon';

import useTranslation from '../../hooks/useTranslation';
import InvestmentsStatement from './InvestmentsStatement';
import './sass/notification.scss';
import './sass/welcomeComp.scss';

const WelcomeComp = ({ user }) => {
  const t = useTranslation();

  const {
    level,
    investorLevel,
    fullName,
    partnerId,
    localized_full_name,
    kyc_positive_result,
    kyc_review_result,
    kyc_status,
  } = user;
  const language = useSelector((state) => state.Layout.language);

  const originLocation = window && window?.location.origin;
  const { photo } = useSelector((state) => ({
    photo: state.Photo.photo,
  }));

  const isVerified =
    kyc_positive_result === true && kyc_review_result === 'GREEN' && kyc_status === 'COMPLETED';

  return (
    <div className="mc-welcome">
      <div className="mc-welcome__head">
        <img
          src={photo ?? DefaultProfileImage}
          alt={`${fullName} photo`}
          className="mc-welcome__avatar"
        />
        <div className="mc-welcome__id">
          <span className="mc-welcome__name">
            {language === 'ru' ? fullName : localized_full_name}
          </span>
          <div className="mc-welcome__level">
            <span className="mc-welcome__level-badge">{Number(level) + 1}</span>
            <div className="mc-welcome__level-meta">
              <p className="mc-welcome__level-text">
                {t('dashboard_your_level')}:{' '}
                <span className="mc-welcome__level-name">{t(`user_levels.level_${level}`)}</span>
              </p>
              {isVerified && (
                <span className="mc-welcome__verified">{t('kyc_account_passed')}</span>
              )}
            </div>
          </div>
        </div>
      </div>

      {investorLevel !== 0 && (
        <div className="mc-welcome__body">
          <p className="mc-welcome__goal">
            {t('dashboard_your_goal', { level: Number(level) + 2 })}
          </p>

          <InvestmentsStatement />

          <div className="mc-welcome__ref">
            <span className="mc-welcome__ref-label">{t('dashboard_your_referral_link')}</span>
            <div className="mc-welcome__ref-value">
              <span className="mc-welcome__ref-id">{partnerId}</span>
              <CopyToClipboard
                text={`${originLocation}/register?partner_id=${partnerId}`}
                onCopy={() => toast.success(t('dashboard_referral_link_copied'))}>
                <button type="button" className="mc-welcome__ref-copy" aria-label="copy">
                  <Icon name="copy" size={18} />
                </button>
              </CopyToClipboard>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const MemoizedWelcomeComp = React.memo(WelcomeComp);

export default MemoizedWelcomeComp;

WelcomeComp.propTypes = {
  user: PropTypes.shape({
    level: PropTypes.string,
    fullName: PropTypes.string,
    partnerId: PropTypes.string,
    deposit: PropTypes.number,
    createdAt: PropTypes.string,
    needToAllStructure: PropTypes.any,
    needToFirstStructure: PropTypes.any,
    kyc_positive_result: PropTypes.bool,
    kyc_review_result: PropTypes.string,
    kyc_status: PropTypes.string,
  }),
};
